export default __webpack_public_path__ + "8da6c15d70e03b3100d1e08d84e55c46.png";